import * as React from 'react';
import Typography from '@material-ui/core/Typography';

import {
  SuitableForFilterValue,
  SuitableForValue,
} from 'ha/types/SearchFilters';
import { withIntl, IntlProps } from 'ha/i18n';
import FilterCheckbox from './FilterCheckbox';

interface Props {
  suitableFor: SuitableForFilterValue;
  onToggle: (selection: SuitableForValue, selected: boolean) => void;
}

export const SuitableForFilter: React.SFC<Props & IntlProps> = ({
  suitableFor,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Suitable for')}</Typography>

    <FilterCheckbox
      name={SuitableForValue.Students}
      onToggle={(selected: boolean) =>
        onToggle(SuitableForValue.Students, selected)
      }
      isActive={suitableFor.includes(SuitableForValue.Students)}
      data-test-locator="Filter Students"
    >
      {T('Students')}
    </FilterCheckbox>
    <FilterCheckbox
      name={SuitableForValue.WorkingProfessionals}
      onToggle={(selected: boolean) =>
        onToggle(SuitableForValue.WorkingProfessionals, selected)
      }
      isActive={suitableFor.includes(SuitableForValue.WorkingProfessionals)}
      data-test-locator="Filter Working Professionals"
    >
      {T('Working professionals')}
    </FilterCheckbox>
    <FilterCheckbox
      name={SuitableForValue.Couples}
      onToggle={(selected: boolean) =>
        onToggle(SuitableForValue.Couples, selected)
      }
      isActive={suitableFor.includes(SuitableForValue.Couples)}
      data-test-locator="Filter Couples"
    >
      {T('Couples')}
    </FilterCheckbox>
  </React.Fragment>
);

export default withIntl(SuitableForFilter);
